import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import CartSidebarPrice from './CartSidebarPrice.vue';
import CompactWarrantyOption from './CompactWarrantyOption.vue';
import FulfillmentInfo from './FulfillmentInfo.vue';
import ProductService, { AddToCartProduct } from 'JS/services/ProductService';
import { addWarranty } from 'JS/pdp/services/AddToCartService';
import { computed, onMounted, ref, watch } from 'vue';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IWarranty } from 'JS/types/Product';
import { useBreakpoints, useViewportWidth } from 'JS/composables/breakpoint';
import { useListSlider } from "JS/composables/list-slider";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleProductSummary',
  props: {
    products: null,
    fulfillmentType: null,
    shippingDeliveryDate: null,
    shipZip: null,
    localStore: null
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', loading: boolean): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	products: AddToCartProduct[],
	fulfillmentType: FulfillmentType,
	shippingDeliveryDate: string,
	shipZip: string,
	localStore: ILocalStoreJson,
}





const productService: ProductService = new ProductService();
const warrantyList = ref<Map<AddToCartProduct, {warrantySelected: boolean, warrantyError: boolean}>>(null);
const hasWarranties = computed<boolean>(() => props.products.filter(p => !!p.warrantyOptions)?.length > 0);

const { isMobile } = useBreakpoints();
const useSlider = computed<boolean>(() => props.products.length > 3 && !hasWarranties.value);
const showSliderButtons = computed<boolean>(() => !isMobile.value && useSlider.value);
const { next, previous, viewport, slider } = useListSlider();
const viewportWidth = useViewportWidth();
watch(() => viewportWidth.value, () => {
	slider.value?.reset();
});

const subtotal = computed<string>(() => {
	let total = 0;
	props.products.forEach(product => {
		total += product.addToCartPriceModel.lineTotal;
		if (!!product.warrantyOptions && warrantyList.value?.get(product)?.warrantySelected) {
			total += product.warrantyOptions.preferredWarranty.price;
		}
	});
	return "$" + total.toCurrency();
});

onMounted(() => {
	if (hasWarranties.value) {
		warrantyList.value = new Map(props.products.map(
			(product) => [product, { warrantySelected: false, warrantyError: false }]));
	}
});

async function warrantySelectionChanged(product: AddToCartProduct, preferredWarranty: IWarranty) {
	emit('loading', true);
	const warrantyInfo = warrantyList.value.get(product);
	try {
		if (!warrantyInfo.warrantySelected) {
			const response = await addWarranty(
				product.blainNumber,
				product.quantity,
				preferredWarranty.blainNumber
			);
			if (response.success) {
				warrantyInfo.warrantyError = false;
				warrantyInfo.warrantySelected = true;
			} else {
				warrantyInfo.warrantyError = true;
			}
		} else {
			const success = await productService.removeWarranty({
				warrantySku: preferredWarranty.blainNumber,
				warrantyQty: product.quantity,
				productBlainNumber: product.blainNumber
			});
			if (success) {
				warrantyInfo.warrantyError = false;
				warrantyInfo.warrantySelected = false;
			} else {
				warrantyInfo.warrantyError = true;
			}
		}
	} catch (e) {
		bugsnagClient.notify(e);
		warrantyInfo.warrantyError = true;
	} finally {
		warrantyList.value.set(product, warrantyInfo);
		// TODO: Maps are reactive in Vue 3, but Vue 2 requires us to create a new one
		warrantyList.value = new Map(warrantyList.value);
		emit('loading', false);
	}
}


return { __sfc: true,props, emit, productService, warrantyList, hasWarranties, isMobile, useSlider, showSliderButtons, next, previous, viewport, slider, viewportWidth, subtotal, warrantySelectionChanged, CartSidebarPrice, CompactWarrantyOption, FulfillmentInfo }
}

})